import React from 'react';
import Literaryclub2023 from 'views/Literaryclub2023';
import { EnglishCCAReaction } from 'views/Literaryclub2023/components';

const LifeSkillPage = () => {
  return <EnglishCCAReaction/>;
};

export default LifeSkillPage;